import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { GlobalStyles } from "./GlobalStyles";
import Pages from './pages'

export default function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <Pages />
    </BrowserRouter>
  )
}
